exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header-table-offers {\n\tbackground-color: #00a09c;\n\tborder: 1px solid #ddd !important;\n\tmargin-left: 0px;\n\tmargin-right: 0;\n}\n.header-table-offers > div {\n\tborder-right: 1px solid #ddd !important;\n\tpadding-top: 10px;\n\tpadding-bottom: 10px;\n\tfont-weight: bolder;\n\tcolor: white;\n}\n.content-table-offers .row {\n\t/* border: 1px solid #ddd !important; */\n\tmargin-left: 0px;\n\tmargin-right: 0;\n}\n.content-table-offers .row:hover {\n\tbackground-color: #f3f5f7;\n}\n.content-table-offers .row div {\n\tborder-right: 1px solid #ddd !important;\n\tpadding-top: 5px;\n\tpadding-bottom: 5px;\n}\n", ""]);

// exports
